// 22.01.19 - Here we create our new state store and setup the Redux Saga middleware so that the Saga has access to the stream of actions.
import { createBrowserHistory } from "history";
import { routerMiddleware } from "connected-react-router";
import { applyMiddleware, createStore, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import createRootReducer from "../reducers";
import rootSaga from "../saga";
import { fetchInitialData } from "src/actions/home";
import { loggedIn } from "src/actions/common";

export const history = createBrowserHistory();

const middleware = routerMiddleware(history);
const sagaMiddleWare: any = createSagaMiddleware();

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const configStore = () => {
  // Call by App.tsx.
  const store = createStore(
    createRootReducer(history),
    composeEnhancers(applyMiddleware(middleware, sagaMiddleWare))
  );
  // Set the initial user
  sagaMiddleWare.run(rootSaga);

  // This fetch our initial data and the first event in the stream.
  store.dispatch(fetchInitialData());

  // Check whether a user is logged in or not
  const userToken = localStorage.getItem("msal.idtoken");
  if (userToken) {
    store.dispatch(loggedIn(true));
  }

  return store;
};
